import * as React from 'react';


export function convertHTMLJSON(html) {
    var html2json = require('html2json').html2json;
    return (html ? html2json(html) : {});
}

